"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[21],{

/***/ 25021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SelectTab": function() { return /* binding */ SelectTab; },
  "default": function() { return /* binding */ components_CompanyDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(36802);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useIdentify/index.js
var useIdentify = __webpack_require__(205);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/HogProvider/index.js
var HogProvider = __webpack_require__(74313);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./store/index.tsx + 1 modules
var store = __webpack_require__(13448);
// EXTERNAL MODULE: ./store/actions.ts
var actions = __webpack_require__(47806);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SlideShow/index.js + 3 modules
var SlideShow = __webpack_require__(5817);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/index.js + 620 modules
var components = __webpack_require__(89391);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/AboutUs/AboutUs.css.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border: 1px solid ",
        ";\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                padding: 0;\n                background-color: unset;\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        ";\n    background-color: ",
        ";\n    border-radius: 6px 6px 0 0;\n    ",
        "\n    @media screen and (max-width: ",
        "px) {\n        border: unset;\n        ",
        "\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 22px;\n    color: ",
        ";\n    white-space: pre-line;\n    overflow: hidden;\n    transition: max-height 0.15s ease-in-out;\n    margin-bottom: 16px;\n    @media screen and (max-width: ",
        "px) {\n        margin-bottom: 8px;\n    }\n    max-height: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 16px;\n    color: ",
        ";\n    cursor: pointer;\n    &:hover {\n        color: ",
        ";\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    overflow: hidden;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    row-gap: 10px;\n    padding: 0;\n    margin-bottom: 25px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: auto 1fr;\n    @media screen and (max-width: ",
        "px) {\n        grid-template-columns: 1fr;\n        row-gap: 4px;\n    }\n    > .type {\n        line-height: 22px;\n        font-weight: 500;\n        color: ",
        ";\n        width: 100px;\n        margin-bottom: 0;\n    }\n    > .text {\n        margin-bottom: 0;\n        color: ",
        ";\n        line-height: 22px;\n        > .dangerously-text {\n            width: fit-content;\n            display: inline-block;\n        }\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: 12px;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    width: 100%;\n    aspect-ratio: 3/2;\n    overflow: hidden;\n    ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 22px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 30px;\n    @media screen and (max-width: ",
        "px) {\n        font-size: 15px;\n        margin: 0 0 10px 0;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var CompanyImagePreview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f4c261d-0"
})(_templateObject2(), function(param) {
    var isEmpty = param.isEmpty;
    return isEmpty ? "0 50px 12px 50px" : "25px 25px 10px 25px";
}, function(param) {
    var isEmpty = param.isEmpty;
    return isEmpty ? "#F6F8FB" : "#f4f4f7";
}, function(param) {
    var isEmpty = param.isEmpty;
    if (isEmpty) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), components.Colors.cardShadow);
}, responsiveHelper/* screens.mobile */.FB.mobile, function(param) {
    var isEmpty = param.isEmpty;
    if (isEmpty) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var AboutUsDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7f4c261d-1"
})(_templateObject3(), components.Colors.text, responsiveHelper/* screens.mobile */.FB.mobile, function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
});
var ReadMoreButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7f4c261d-2"
})(_templateObject4(), components.Colors.primary, components.Colors.button);
var AboutUsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f4c261d-3"
})(_templateObject5());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f4c261d-4"
})(_templateObject6());
var InformationList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7f4c261d-5"
})(_templateObject7());
var InformationItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7f4c261d-6"
})(_templateObject8(), responsiveHelper/* screens.mobile */.FB.mobile, components.Colors.text, components.Colors.text);
var AspectRatioContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f4c261d-7"
})(_templateObject10(), function(param) {
    var hasBorderRadius = param.hasBorderRadius;
    if (!hasBorderRadius) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});
var H2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-7f4c261d-8"
})(_templateObject11(), components.Colors.text, responsiveHelper/* screens.mobile */.FB.mobile);

// EXTERNAL MODULE: ./helpers/common.ts + 3 modules
var common = __webpack_require__(3298);
;// CONCATENATED MODULE: ./components/AboutUs/index.tsx







var DESCRIPTION_MAX_HEIGHT = 200;
var OFFSET = 5;
var EMPTY_IMAGE = "".concat("https://images.vietnamworks.com", "/company-assets/images/icon-workingoffice1x.png");
var GOOGLE_MAP_URL = "https://www.google.com/maps";
var AboutUs = function(param) {
    var t = param.t, companyInfo = param.companyInfo, ociData = param.ociData;
    var isRobot = (0,store.useStore)().state.isRobot;
    var ref = companyInfo || {}, companyContactName = ref.contactName, companyProfile = ref.companyProfile, companySizeName = ref.companySizeName, jobImageURLs = ref.jobImageURLs, companyAddress = ref.address;
    var ref1 = (0,react.useState)(false), canExtend = ref1[0], setCanExtend = ref1[1];
    var ref2 = (0,react.useState)(false), extend = ref2[0], setExtend = ref2[1];
    var ref3 = (0,react.useState)(0), descriptionContentHeight = ref3[0], setDescriptionContentHeight = ref3[1];
    var descriptionRef = (0,react.useRef)(null);
    var handleExtendDescription = function() {
        setExtend(!extend);
    };
    var isPublicOCI = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 2 || (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 3;
    var categories = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.industryNames;
    var companySize = (ociData === null || ociData === void 0 ? void 0 : ociData.companySize) || companySizeName;
    var aboutUsImages = (0,react.useMemo)(function() {
        if ((ociData === null || ociData === void 0 ? void 0 : ociData.companyImages) && (ociData === null || ociData === void 0 ? void 0 : ociData.companyImages.length) > 0) {
            return ociData === null || ociData === void 0 ? void 0 : ociData.companyImages;
        }
        if (jobImageURLs && jobImageURLs.length > 0) {
            return jobImageURLs.filter(function(image) {
                return image !== "";
            });
        }
        return [];
    }, [
        jobImageURLs,
        ociData === null || ociData === void 0 ? void 0 : ociData.companyImages
    ]);
    var address = (0,react.useMemo)(function() {
        var tempAddress = "";
        if (ociData === null || ociData === void 0 ? void 0 : ociData.headquaterAddress) {
            tempAddress = ociData === null || ociData === void 0 ? void 0 : ociData.headquaterAddress;
        } else {
            tempAddress = companyAddress || "";
        }
        return (0,common/* stripHtml */.Vt)(tempAddress);
    }, [
        companyAddress,
        ociData === null || ociData === void 0 ? void 0 : ociData.headquaterAddress
    ]);
    var contactName = (0,react.useMemo)(function() {
        if (ociData === null || ociData === void 0 ? void 0 : ociData.companyContact) {
            return ociData.companyContact;
        }
        return companyContactName || null;
    }, [
        ociData === null || ociData === void 0 ? void 0 : ociData.companyContact,
        companyContactName
    ]);
    (0,react.useEffect)(function() {
        if (descriptionRef && descriptionRef.current) {
            var textNode = descriptionRef.current.childNodes[0];
            if (textNode) {
                var range = document.createRange();
                range.selectNodeContents(textNode);
                var textNodeHeight = range.getBoundingClientRect().height + OFFSET;
                if (textNodeHeight > DESCRIPTION_MAX_HEIGHT) {
                    setCanExtend(true);
                    setDescriptionContentHeight(textNodeHeight);
                }
            }
        }
    }, [
        companyInfo
    ]);
    /*
     * Check for company oci profile
     * */ var getCompanyProfile = companyProfile;
    if (isPublicOCI) {
        getCompanyProfile = (ociData === null || ociData === void 0 ? void 0 : ociData.companyProfile) || companyProfile;
    }
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: t("About Us")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                gutter: [
                    24,
                    35
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        xs: 24,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationList, {
                                children: [
                                    companySize && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "type",
                                                children: t("Size")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text",
                                                children: "".concat(companySize, " ").concat(t("staffs"))
                                            })
                                        ]
                                    }),
                                    categories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "type",
                                                children: t("Industry")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text",
                                                children: categories
                                            })
                                        ]
                                    }),
                                    contactName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "type",
                                                children: t("Contact")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text",
                                                children: contactName
                                            })
                                        ]
                                    }),
                                    address && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "type",
                                                children: t("Address")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "dangerously-text",
                                                        dangerouslySetInnerHTML: {
                                                            __html: address
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Anchor */.ee, {
                                                        name: "paragraph",
                                                        size: "medium",
                                                        href: "".concat(GOOGLE_MAP_URL, "?q=").concat(address),
                                                        target: "_blank",
                                                        color: Colors/* colors.primary.40 */.O9.primary[40],
                                                        style: {
                                                            marginLeft: 8
                                                        },
                                                        children: [
                                                            "(",
                                                            t("View map"),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsDescription, {
                                ref: descriptionRef,
                                maxHeight: extend ? descriptionContentHeight : DESCRIPTION_MAX_HEIGHT,
                                children: getCompanyProfile
                            }),
                            canExtend && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreButton, {
                                onClick: handleExtendDescription,
                                children: extend ? t("Show less") : t("Read more")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 24,
                        children: aboutUsImages && aboutUsImages.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                maxWidth: isPublicOCI ? 720 : "100%",
                                margin: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideShow/* default */.Z, {
                                id: "company-image",
                                slides: {
                                    elementPerView: 1
                                },
                                autoEnable: true,
                                transitionTime: 500,
                                autoTime: 5000,
                                isRobot: isRobot,
                                pagination: {
                                    maxShow: 5
                                },
                                children: aboutUsImages === null || aboutUsImages === void 0 ? void 0 : aboutUsImages.map(function(url, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AspectRatioContainer, {
                                        hasBorderRadius: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: url,
                                                alt: (ref4 = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) !== null && ref4 !== void 0 ? ref4 : "",
                                                layout: "fill",
                                                objectFit: "contain"
                                            })
                                        })
                                    }, "".concat(url, "-").concat(index));
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyImagePreview, {
                            isEmpty: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectRatioContainer, {
                                hasBorderRadius: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: EMPTY_IMAGE,
                                        alt: (ref5 = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) !== null && ref5 !== void 0 ? ref5 : "",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AboutUs = (AboutUs);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useElementSize.js
var useElementSize = __webpack_require__(19191);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/index.js + 8 modules
var ReportCompanyModal = __webpack_require__(52665);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ShareButton/index.js + 2 modules
var ShareButton = __webpack_require__(32053);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
// EXTERNAL MODULE: ./components/Banner/Banner.css.tsx
var Banner_css = __webpack_require__(68276);
// EXTERNAL MODULE: ./services/companyDetailService.ts + 1 modules
var companyDetailService = __webpack_require__(19886);
// EXTERNAL MODULE: ./components/constants.tsx
var components_constants = __webpack_require__(70586);
// EXTERNAL MODULE: ./services/jobService.ts
var jobService = __webpack_require__(10656);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/Banner/index.tsx

















// const NAV_BAR_HEIGHT = 80
// const NAV_BAR_HEIGHT_MOBILE = 66
var NAV_BAR_HEIGHT = 0;
var NAV_BAR_HEIGHT_MOBILE = 64;
var Banner = function(props) {
    var t = props.t, companyInfo = props.companyInfo, selectedTab = props.selectedTab, onTabChange = props.onTabChange, companyBannerImage = props.companyBannerImage;
    var _state = (0,store.useStore)().state, langCode = _state.langCode, isMobile = _state.isMobile, user = _state.user;
    // Sticky banner
    var ref = (0,react.useState)({
        stopDetectFixedHeader: true,
        fixedOffset: 0,
        bannerBarShortHeight: isMobile ? 190 : 250 // Fixed header height
    }), stickyData = ref[0], setStickyData = ref[1];
    // Follow
    var ref1 = (0,react.useState)(companyInfo !== null ? companyInfo.isFollowed === 1 : false), isFollowed = ref1[0], setFollowed = ref1[1];
    var ref2 = (0,react.useState)(companyInfo !== null ? companyInfo.totalFollow : 1), followCount = ref2[0], setFollowCount = ref2[1];
    // Unfollow dialog
    var ref3 = (0,react.useState)(false), isShowUnfollowDialog = ref3[0], setShowUnfollowDialog = ref3[1];
    var mainBannerRef = (0,react.useRef)(null);
    var tabBarWrapperRef = (0,react.useRef)(null);
    var tabBarRef = (0,react.useRef)(null);
    var tabSectionWrapperRef = (0,react.useRef)(null);
    var tabSectionRef = (0,react.useRef)(null);
    var data = {
        apiGetway: "https://ms.vietnamworks.com" + "/company-profile/v1.0",
        apiTokenAccess: (user === null || user === void 0 ? void 0 : user.accessToken) || "",
        isAuthenticated: user !== null && user.accessToken ? 1 : 0,
        userId: (user === null || user === void 0 ? void 0 : user.userId) || 0,
        isReportCompany: !!(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isReported),
        imagesService: "https://images.vietnamworks.com" || 0,
        company: {
            companyName: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || "",
            companyLogo: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) || "",
            companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0
        }
    };
    var doFollow = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isFollowed) {
            var response, toastTitle, toastMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (user === null || !user.accessToken) {
                            return [
                                2
                            ];
                        }
                        if (companyInfo === null || !companyInfo.companyId) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,companyDetailService/* companyFollow */.cP)(companyInfo.companyId, isFollowed, user === null || user === void 0 ? void 0 : user.accessToken, langCode)
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : response.code) !== jobService/* DEFAULT_SUCCESS_CODE */.se) {
                            return [
                                2
                            ];
                        }
                        toastTitle = t("Unfollowed");
                        toastMessage = t("You'll stop receive the newest jobs from this company.");
                        if (isFollowed) {
                            toastTitle = t("Yay! Thanks for following");
                            toastMessage = t("You will receive the newest jobs from this company.");
                        }
                        Toast/* showToast */.CF(toastTitle, toastMessage, "success");
                        return [
                            2
                        ];
                }
            });
        });
        return function(isFollowed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        companyInfo,
        langCode,
        t,
        user
    ]);
    var changeFollowState = (0,react.useCallback)(function(followed) {
        setFollowed(followed);
        setFollowCount(followed ? followCount + 1 : followCount - 1);
        // Call API to update follow
        doFollow(followed);
    }, [
        doFollow,
        followCount
    ]);
    var onClickFollowUs = (0,react.useCallback)(function() {
        if (user === null || !user.accessToken) {
            (0,common/* showLoginModal */.m8)(langCode);
            return;
        }
        if (companyInfo === null || !companyInfo.companyId) {
            return;
        }
        var followed = !isFollowed;
        if (!followed) {
            setShowUnfollowDialog(true);
        } else {
            changeFollowState(followed);
        }
    }, [
        changeFollowState,
        companyInfo,
        isFollowed,
        langCode,
        user
    ]);
    var onClickTabItem = (0,react.useCallback)(function(tab, tabName) {
        var element = document.getElementById(tabName);
        onTabChange(tab);
        if (element === undefined || element === null) {
            return;
        }
    }, [
        onTabChange
    ]);
    var tabSectionScrollTo = (0,react.useCallback)(function(position) {
        if (tabSectionRef && tabSectionRef.current) {
            tabSectionRef.current.scrollTo({
                left: position,
                behavior: "smooth"
            });
        }
    }, []);
    var onClickConfirmUnfollow = (0,react.useCallback)(function() {
        changeFollowState(false);
        setShowUnfollowDialog(false);
    }, [
        changeFollowState
    ]);
    (0,react.useEffect)(function() {
        if (tabSectionRef.current) {
            var tabSectionChildren = tabSectionRef.current.childNodes;
            var left = tabSectionChildren[selectedTab].getBoundingClientRect().left;
            tabSectionScrollTo(left);
        }
    }, [
        selectedTab,
        tabSectionScrollTo
    ]);
    (0,react.useEffect)(function() {
        // Fixed Banner full height
        var handleScrolling = function() {
            setStickyData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stickyData), {
                fixedOffset: window.scrollY
            }));
            if (mainBannerRef && mainBannerRef.current && tabBarRef && tabBarRef.current && tabBarWrapperRef && tabBarWrapperRef.current) {
                var tabBarHeight = tabBarRef.current.getBoundingClientRect().height;
                var mainBannerElement = mainBannerRef.current;
                var bottom = mainBannerElement.getBoundingClientRect().bottom;
                var navBarHeight = isMobile ? NAV_BAR_HEIGHT_MOBILE : NAV_BAR_HEIGHT;
                var mainBannerPosition = bottom - tabBarHeight - navBarHeight;
                if (mainBannerPosition <= 0) {
                    tabBarRef.current.classList.add("sticky");
                    tabBarWrapperRef.current.classList.add("sticky");
                    mainBannerElement.style.paddingBottom = "".concat(tabBarHeight, "px");
                } else {
                    tabBarRef.current.classList.remove("sticky");
                    tabBarWrapperRef.current.classList.remove("sticky");
                    mainBannerElement.style.paddingBottom = "unset";
                }
            }
        };
        window.addEventListener("scroll", handleScrolling, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScrolling);
        };
    }, [
        isMobile,
        stickyData
    ]);
    (0,react.useEffect)(function() {
        if (companyInfo !== null) {
            setFollowed(companyInfo !== null ? companyInfo.isFollowed === 1 : false);
            setFollowCount(companyInfo !== null ? companyInfo.totalFollow : 1);
        }
    }, [
        companyInfo
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)(useElementSize/* default */.Z(), 2), setRef = ref4[0], mainBannerSize = ref4[1];
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* ContentWrapper */.vs, {
        ref: function(node) {
            mainBannerRef.current = node;
            setRef(node);
        },
        id: "bannerSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: companyBannerImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* ContanerWithBg */.Dg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* BackgroundContainer */.H_, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* MainBackgroundImage */.hV, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: companyBannerImage,
                                alt: (ref5 = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) !== null && ref5 !== void 0 ? ref5 : "",
                                priority: true,
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* MainContent */.M9, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* Avatar */.qE, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        backgroundImage: "url('".concat(companyInfo && companyInfo.companyLogoURL !== "" ? companyInfo.companyLogoURL : components_constants/* EMPTY_COMPANY_IMAGE */.I7, "')"),
                                        backgroundSize: "contain",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        display: "block",
                                        width: "100%",
                                        height: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* CompanyInfo */.zW, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* CompanyName */.zo, {
                                        children: (ref6 = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) !== null && ref6 !== void 0 ? ref6 : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* CompanyAddress */.QU, {
                                        isNoMarginBottom: true,
                                        children: [
                                            followCount,
                                            " ",
                                            followCount > 1 ? t("followers") : t("follower")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* FollowAction */.AE, {
                                isMobile: isMobile,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "primary",
                                        isOutline: isFollowed,
                                        onClick: onClickFollowUs,
                                        children: isFollowed ? t("Following") : t("Follow")
                                    }),
                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportCompanyModal/* default */.Z, {
                                        language: langCode,
                                        data: data,
                                        useGlobalToast: true,
                                        locationClassName: ""
                                    }),
                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton/* default */.Z, {
                                        langCode: langCode,
                                        position: "right",
                                        buttonStyle: {
                                            padding: 8
                                        }
                                    }),
                                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportCompanyModal/* default */.Z, {
                                        language: langCode,
                                        data: data,
                                        useGlobalToast: false,
                                        locationClassName: ""
                                    }),
                                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton/* default */.Z, {
                                        langCode: langCode,
                                        position: "right",
                                        buttonStyle: {
                                            padding: 8,
                                            width: 40
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* TabAndShareWrapper */.lk, {
                        ref: tabBarWrapperRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* TabAndShare */.Cx, {
                            ref: tabBarRef,
                            offset: NAV_BAR_HEIGHT,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* TabSectionWrapper */.o2, {
                                ref: tabSectionWrapperRef,
                                width: mainBannerSize.width - 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* TabSection */.tJ, {
                                    ref: tabSectionRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* TabItem */.E2, {
                                            id: "AboutUs-tab",
                                            isSelected: selectedTab === SelectTab.ABOUT_US,
                                            onClick: function() {
                                                return onClickTabItem(SelectTab.ABOUT_US, "AboutUs");
                                            },
                                            children: t("About Us")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* TabItem */.E2, {
                                            id: "OpeningJob-tab",
                                            isSelected: selectedTab === SelectTab.OPENING_JOB,
                                            onClick: function() {
                                                return onClickTabItem(SelectTab.OPENING_JOB, "OpeningJob");
                                            },
                                            children: t("Opening Jobs")
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            isShowUnfollowDialog && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup/* default */.Z, {
                isShow: isShowUnfollowDialog,
                lang: langCode,
                styleOption: {
                    size: "sm"
                },
                text: {
                    header: t("Unfollow company?"),
                    primaryBtn: t("Unfollow")
                },
                onClose: function() {
                    return setShowUnfollowDialog(false);
                },
                onClickPrimary: onClickConfirmUnfollow,
                children: t("You will not able to received notifications from this company.")
            })
        ]
    });
};
/* harmony default export */ var components_Banner = (Banner);

;// CONCATENATED MODULE: ./components/CompanyDetail/CompanyDetail.css.tsx

function CompanyDetail_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 24px;\n    border-radius: 12px;\n    overflow: hidden;\n    background-color: #fff;\n    @media (max-width: 768px) {\n        padding: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        background-color: unset;\n    }\n"
    ]);
    CompanyDetail_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 8px;\n    padding: 8px;\n"
    ]);
    CompanyDetail_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #f6f8fb;\n    border-radius: 6px;\n    padding: 80px 40px;\n    text-align: center;\n    margin-top: 24px;\n    p {\n        font-size: 14px;\n        line-height: 16px;\n        color: #777;\n        margin: 17px 0 0 0;\n    }\n    @media (max-width: 768px) {\n        svg {\n            width: 100%;\n        }\n    }\n"
    ]);
    CompanyDetail_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n    }\n"
    ]);
    CompanyDetail_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1; /* Each child takes up 50% of the available space */\n    display: flex;\n    flex-direction: column;\n"
    ]);
    CompanyDetail_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-grow: 1;\n    @media (max-width: 768px) {\n        height: 240px;\n    }\n"
    ]);
    CompanyDetail_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n"
    ]);
    CompanyDetail_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    user-select: none;\n    pointer-events: none;\n    height: 50vh;\n    @media (min-width: 992px) {\n        width: 100%;\n        padding: 16px;\n    }\n    @media (min-width: 1200px) {\n        max-width: 1170px;\n    }\n"
    ]);
    CompanyDetail_css_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CompanyDetail_css_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 12px;\n"
    ]);
    CompanyDetail_css_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var CompanyPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-0"
})(CompanyDetail_css_templateObject());
var BreadcrumbStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-1"
})(CompanyDetail_css_templateObject1());
var EmptyDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-2"
})(CompanyDetail_css_templateObject2());
// Define a wrapper component
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-3"
})(CompanyDetail_css_templateObject3());
// Define two child divs with 50% width and 360px height
var ChildCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-4"
})(CompanyDetail_css_templateObject4());
var MapWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-5"
})(CompanyDetail_css_templateObject5());
var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-6"
})(CompanyDetail_css_templateObject6());
var MainTopDetector = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-941f77e8-7"
})(CompanyDetail_css_templateObject7());
var ContentWithBordered = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z).withConfig({
    componentId: "sc-941f77e8-8"
})(CompanyDetail_css_templateObject8());

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(50697);
;// CONCATENATED MODULE: ./components/Benefit/Benefit.css.tsx

function Benefit_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    margin: -10px;\n    transition: all 0.25s;\n    @media (max-width: 991px) {\n        grid-template-columns: repeat(1, 1fr);\n    }\n"
    ]);
    Benefit_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			transform: rotate(-180deg);\n			transition: all 0.25s;\n		"
    ]);
    Benefit_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	transition: all 0.25s;\n	width: 24px;\n	height: 24px;\n	",
        "\n"
    ]);
    Benefit_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n"
    ]);
    Benefit_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: auto;\n	padding: 44px 24px;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 16px;\n	border-radius: 12px;\n	background-color: ",
        ";\n	text-align: center;\n"
    ]);
    Benefit_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: -webkit-box;\n	-webkit-line-clamp: 2;\n	-webkit-box-orient: vertical;\n	overflow: hidden;\n	font-size: 14px;\n	font-weight: 600;\n	max-width: 224px;\n	color: #333;\n	height: 36px;\n	line-height: 18px;\n	position: relative;\n	width: 100%;\n	text-align: center;\n"
    ]);
    Benefit_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	content: '';\n	width: 106px;\n	height: 1px;\n	background-color: ",
        ";\n	position: absolute;\n	bottom: 0;\n	left: 50%;\n	transform: translateX(-50%);\n"
    ]);
    Benefit_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 14px;\n	line-height: 24px;\n	color: #333;\n	height: 200px;\n	overflow-y: auto;\n	margin-bottom: 0;\n	padding: 0 16px;\n	width: 100%;\n	white-space: pre-line;\n	background-color: ",
        ";\n"
    ]);
    Benefit_css_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	background: ",
        " !important;\n	border: none;\n	padding: 12px 20px;\n	border-radius: 6px 6px 0 0;\n	gap: 16px;\n	max-height: 72px;\n	font-weight: 600;\n	span {\n		max-width: calc(100% - 100px);\n		overflow: hidden;\n		text-overflow: ellipsis;\n		display: -webkit-box;\n		-webkit-box-orient: vertical;\n		-webkit-line-clamp: 2;\n	}\n"
    ]);
    Benefit_css_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: ",
        ";\n	width: 100%;\n	padding: 24px 12px;\n	top: 0;\n	right: 0;\n	border: none !important;\n	outline: none !important;\n	margin-top: ",
        ";\n	display: flex;\n	align-items: center;\n	justify-content: end;\n	gap: 5px;\n	background-color: transparent;\n	color: ",
        ";\n	transition: all 0.25s;\n	cursor: pointer;\n	font-weight: 500;\n	opacity: 0.6;\n	font-weight: 600;\n"
    ]);
    Benefit_css_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 16px;\n		margin-top: 24px;\n    flex-direction: ",
        ";\n"
    ]);
    Benefit_css_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Benefit_css_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 184px;\n    height: 80px;\n    position: relative;\n    display: inline-block;\n"
    ]);
    Benefit_css_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	border-radius: 6px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var BenefitCLPList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-0"
})(Benefit_css_templateObject());
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowDownIcon/* default */.Z).withConfig({
    componentId: "sc-d6a527f2-1"
})(Benefit_css_templateObject2(), function(param) {
    var isCollapse = param.isCollapse;
    return isCollapse && (0,styled_components_browser_esm/* css */.iv)(Benefit_css_templateObject1());
});
var IconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-2"
})(Benefit_css_templateObject3());
var _color;
var CardCss = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-3"
})(Benefit_css_templateObject4(), function(props) {
    return (_color = props.color) !== null && _color !== void 0 ? _color : "#fff";
});
var BenefitName = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-d6a527f2-4"
})(Benefit_css_templateObject5());
var Line = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d6a527f2-5"
})(Benefit_css_templateObject6(), Colors/* colors.grey.90 */.O9.grey[90]);
var BenefitDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-6"
})(Benefit_css_templateObject7(), function(param) {
    var bgColor = param.bgColor;
    return bgColor !== null && bgColor !== void 0 ? bgColor : "unset";
});
var HeaderCollapseCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-7"
})(Benefit_css_templateObject8(), function(param) {
    var bgColor = param.bgColor;
    return bgColor !== null && bgColor !== void 0 ? bgColor : "#fff";
});
var CollapseBtnBenefit = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d6a527f2-8"
})(Benefit_css_templateObject9(), function(param) {
    var isAbsolute = param.isAbsolute;
    return isAbsolute ? "absolute" : "static";
}, function(param) {
    var isAbsolute = param.isAbsolute;
    return isAbsolute ? "0" : "10px";
}, components.Colors.text);
var BenefitList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-9"
})(Benefit_css_templateObject10(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "column" : "row";
});
var Benefit_css_ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6a527f2-10"
})(Benefit_css_templateObject11());
var CustomCollapse = (0,styled_components_browser_esm/* default */.ZP)(Collapse/* default */.Z).withConfig({
    componentId: "sc-d6a527f2-11"
})(_templateObject12());

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/BonusIcon/index.js
var BonusIcon = __webpack_require__(27553);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/HealthcarePlanIcon/index.js
var HealthcarePlanIcon = __webpack_require__(82999);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/PaidLeaveIcon/index.js
var PaidLeaveIcon = __webpack_require__(62095);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TrainingIcon/index.js
var TrainingIcon = __webpack_require__(97379);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AwardsIcon/index.js
var AwardsIcon = __webpack_require__(88073);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LibraryIcon/index.js
var LibraryIcon = __webpack_require__(51785);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LaptopIcon/index.js
var LaptopIcon = __webpack_require__(66074);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/MobileIcon/index.js
var MobileIcon = __webpack_require__(1492);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TravelOpportunitiesIcon/index.js
var TravelOpportunitiesIcon = __webpack_require__(61431);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TeamActivitiesIcon/index.js
var TeamActivitiesIcon = __webpack_require__(84485);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TransportationIcon/index.js
var TransportationIcon = __webpack_require__(55007);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CanteenIcon/index.js
var CanteenIcon = __webpack_require__(29683);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/VoucherIcon/index.js
var VoucherIcon = __webpack_require__(7408);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/KindergartenIcon/index.js
var KindergartenIcon = __webpack_require__(21835);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ThreeDotIcon/index.js
var ThreeDotIcon = __webpack_require__(79229);
;// CONCATENATED MODULE: ./components/Benefit/Icon.tsx






function Icon(param) {
    var benefitId = param.benefitId, color = param.color;
    var state = (0,store.useStore)().state;
    var setting = {
        width: state.isMobile ? 48 : 64,
        height: state.isMobile ? 48 : 64
    };
    var renderIcon = function() {
        switch(benefitId){
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BonusIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthcarePlanIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaidLeaveIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 4:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainingIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 5:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardsIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 6:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LibraryIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 7:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LaptopIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 8:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 9:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelOpportunitiesIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 10:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamActivitiesIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 11:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransportationIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 12:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CanteenIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 13:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 14:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(KindergartenIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            case 15:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDotIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
                    color: color
                }));
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrap, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, setting), {
        children: renderIcon()
    }));
};

;// CONCATENATED MODULE: ./components/Benefit/CollapseBenefitCard.tsx




function CollapseBenefitCard(param) {
    var benefit = param.benefit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCollapse, {
        custom: {
            alwaysShowViewMore: true,
            enable: true,
            viewMoreText: function(isCollapse) {
                return isCollapse ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseBtnBenefit, {
                    isAbsolute: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseBtnBenefit, {
                    isAbsolute: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                        isCollapse: true
                    })
                });
            }
        },
        collapse: true,
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCollapseCard, {
            bgColor: Colors/* colors.primary.95 */.O9.primary[95],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    benefitId: benefit.benefitId,
                    color: Colors/* colors.primary.40 */.O9.primary[40]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        " ",
                        benefit.benefitName
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitDescription, {
            bgColor: Colors/* colors.primary.95 */.O9.primary[95],
            style: {
                borderRadius: "0 0 6px 6px",
                height: "auto",
                padding: "0 12px 16px 12px",
                marginBottom: "12px"
            },
            dangerouslySetInnerHTML: {
                __html: benefit.benefitDescription
            }
        })
    });
};

;// CONCATENATED MODULE: ./components/Benefit/BenefitCard.tsx




function BenefitCard(param) {
    var benefit = param.benefit, tmp = param.cardStyle, ref = tmp === void 0 ? {
        bgColor: Colors/* colors.primary.95 */.O9.primary[95],
        iconColor: Colors/* colors.primary.40 */.O9.primary[40]
    } : tmp, bgColor = ref.bgColor, iconColor = ref.iconColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardCss, {
        color: bgColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                benefitId: benefit.benefitId,
                color: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitName, {
                        children: benefit.benefitName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitDescription, {
                dangerouslySetInnerHTML: {
                    __html: benefit.benefitDescription
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/dist/index.modern.js
var index_modern = __webpack_require__(64889);
;// CONCATENATED MODULE: ./components/Benefit/index.tsx












var Benefit_EMPTY_IMAGE = "".concat("https://images.vietnamworks.com", "/company-assets/images/icon-benefits1x.png");
var Benefit = function(props) {
    var t = props.t, companyInfo = props.companyInfo, ociData = props.ociData;
    var _state = (0,store.useStore)().state, isMobile = _state.isMobile, langCode = _state.langCode;
    var companyBenefits;
    if ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyBenefits) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyBenefits.length) > 0) {
        var benefits = index_modern/* initialDataProvider.getBenefits */.Bz.getBenefits();
        companyBenefits = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyBenefits.map(function(item) {
            var ref, ref1;
            var benefitItem = benefits.filter(function(childItem) {
                return childItem.id === item.benefitId;
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                benefitName: langCode === index_modern/* ELanguage.VI */.Df.VI ? (ref = benefitItem[0]) === null || ref === void 0 ? void 0 : ref.name : (ref1 = benefitItem[0]) === null || ref1 === void 0 ? void 0 : ref1.nameEn
            });
        });
    }
    if ((ociData === null || ociData === void 0 ? void 0 : ociData.benefits) && ociData.benefits.length > 0) {
        companyBenefits = ociData === null || ociData === void 0 ? void 0 : ociData.benefits;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("Benefits")
            }),
            !companyBenefits && /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefit_css_ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: Benefit_EMPTY_IMAGE,
                            alt: t("The company has not defined the benefits yet."),
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("The company has not defined the benefits yet.")
                    })
                ]
            }),
            companyBenefits && companyBenefits.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                gutter: 16,
                children: companyBenefits.map(function(benefit, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        sm: 8,
                        xs: 24,
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseBenefitCard, {
                            benefit: benefit
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                            benefit: benefit
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var components_Benefit = (/*#__PURE__*/(0,react.memo)(Benefit));

// EXTERNAL MODULE: ./components/GotoTop/index.tsx + 2 modules
var GotoTop = __webpack_require__(93070);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDebounce.js
var hooks_useDebounce = __webpack_require__(90401);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SearchIcon/index.js
var SearchIcon = __webpack_require__(6538);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleSelect/index.js + 2 modules
var MultipleSelect = __webpack_require__(42865);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/index.js + 9 modules
var MultipleRadio = __webpack_require__(49336);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/index.js + 7 modules
var JobCard = __webpack_require__(58149);
;// CONCATENATED MODULE: ./components/JobList/JobList.css.tsx

function JobList_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    JobList_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobList_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            flex-direction: column;\n            align-items: stretch;\n            gap: 8px;\n        "
    ]);
    JobList_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JobList_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n\n    ",
        "\n"
    ]);
    JobList_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JobList_css_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 0px !important;\n    align-items: center;\n    display: flex;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    line-height: 22px !important;\n"
    ]);
    JobList_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function JobList_css_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 500;\n    display: flex;\n\n    @media screen and (max-width: ",
        "px) {\n        font-size: 15px;\n    }\n"
    ]);
    JobList_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function JobList_css_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    width: ",
        ";\n"
    ]);
    JobList_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function JobList_css_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-grid;\n    pointer-events: ",
        ";\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n    z-index: 1;\n    opacity: 0;\n    transition: 0.25s;\n    cursor: pointer;\n"
    ]);
    JobList_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function JobList_css_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    padding: 8px;\n    border-radius: 6px;\n    background-color: #f4f4f7;\n    display: flex;\n    align-items: center;\n    height: 40px;\n    flex: 1;\n\n    &:hover ",
        " {\n        opacity: ",
        ";\n        :hover {\n            opacity: 1;\n        }\n    }\n"
    ]);
    JobList_css_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function JobList_css_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    line-height: 16px;\n    margin-left: 8px;\n    padding-right: 24px;\n    background-color: transparent;\n    outline: none;\n    border: none;\n    width: 100%;\n\n    &:focus ~ ",
        " {\n        opacity: ",
        ";\n    }\n"
    ]);
    JobList_css_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function JobList_css_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 184px;\n    height: 80px;\n    position: relative;\n    display: inline-block;\n"
    ]);
    JobList_css_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function JobList_css_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    padding-top: 10px;\n    padding-bottom: ",
        ";\n"
    ]);
    JobList_css_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function JobList_css_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    row-gap: 8px;\n"
    ]);
    JobList_css_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var JobListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-0"
})(JobList_css_templateObject());
var JobListHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-1"
})(JobList_css_templateObject2(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(JobList_css_templateObject1());
});
var JobListTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-648f29f7-2"
})(JobList_css_templateObject3());
var JobAmount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-3"
})(JobList_css_templateObject4(), Colors/* colors.grey.60 */.O9.grey[60], responsiveHelper/* screens.mobile */.FB.mobile);
var JobListFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-4"
})(JobList_css_templateObject5(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "100%" : "400px";
});
var SearchRemoveIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-5"
})(JobList_css_templateObject6(), function(param) {
    var isDisplay = param.isDisplay;
    return isDisplay ? "all" : "none";
});
var SearchBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-6"
})(JobList_css_templateObject7(), SearchRemoveIcon, function(param) {
    var isDisplayRemoveIcon = param.isDisplayRemoveIcon;
    return isDisplayRemoveIcon ? 0.5 : 0;
});
var SearchInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-648f29f7-7"
})(JobList_css_templateObject8(), SearchRemoveIcon, function(param) {
    var isDisplayRemoveIcon = param.isDisplayRemoveIcon;
    return isDisplayRemoveIcon ? 0.5 : 0;
});
var JobList_css_ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-8"
})(JobList_css_templateObject9());
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-9"
})(JobList_css_templateObject10(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "10px" : 0;
});
var JobCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-648f29f7-10"
})(JobList_css_templateObject11());

;// CONCATENATED MODULE: ./components/JobList/services.ts



var getFilterParse = function(locationId, companyId) {
    var filter = [];
    filter.push({
        field: "companyId",
        value: String(companyId)
    });
    filter.push({
        field: "isAnonymous",
        value: "false"
    });
    if (Array.isArray(locationId) && locationId.length > 0) {
        filter.push({
            field: "workingLocations.cityId",
            value: locationId.join(",")
        });
    }
    return filter;
};
var doGetJobList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, accessToken, searchQuery, page, locationIds, userId, hitsPerPage, langCode) {
        var ref, jobs, jobLocations, jobTotal, filter, response, listJobId, _tmp, isLoggedIn, responseSpecial, mappedJobList, ref1, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jobs = [];
                    jobLocations = [];
                    jobTotal = 0;
                    filter = getFilterParse(locationIds, companyId);
                    return [
                        4,
                        (0,jobService/* getJobListFromCompany */.ok)(accessToken || "", filter, page, searchQuery, userId, hitsPerPage, langCode)
                    ];
                case 1:
                    response = _state.sent();
                    listJobId = response.data && response.data.map(function(jobItem) {
                        return jobItem.jobId;
                    }) || [];
                    _tmp = {};
                    // Get special job (matching, applied, saved)
                    if (listJobId.length === 0) {
                        return [
                            2,
                            (_tmp.jobs = [], _tmp.jobTotal = 0, _tmp)
                        ];
                    }
                    isLoggedIn = true;
                    if (accessToken === "") {
                        isLoggedIn = false;
                    }
                    if (!isLoggedIn) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,jobService/* getSpecialJob */.nL)(listJobId, accessToken || "")
                    ];
                case 2:
                    responseSpecial = _state.sent();
                    mappedJobList = response.data && response.data.map(function(job) {
                        var ref;
                        var saveJobArr = (ref = responseSpecial.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return item.id === job.jobId;
                        });
                        if (saveJobArr && (saveJobArr === null || saveJobArr === void 0 ? void 0 : saveJobArr.length) > 0) {
                            job.isApplied = saveJobArr[0].attributes.applied;
                            job.isSaved = saveJobArr[0].attributes.saved;
                            job.isMatching = saveJobArr[0].attributes.matching;
                            job.isBlackList = saveJobArr[0].attributes.userBlackList;
                            var _jobInvitation;
                            job.jobInvitation = (_jobInvitation = saveJobArr[0].attributes.jobInvitation) !== null && _jobInvitation !== void 0 ? _jobInvitation : {
                                jobInvitationId: 0,
                                status: 0
                            };
                        }
                        return job;
                    });
                    jobs = mappedJobList || [];
                    return [
                        3,
                        4
                    ];
                case 3:
                    jobs = (response === null || response === void 0 ? void 0 : response.data) || [];
                    _state.label = 4;
                case 4:
                    if (response && response.meta) {
                        jobTotal = response.meta.nbHits || 0;
                    }
                    if (response && ((ref = response.facets) === null || ref === void 0 ? void 0 : ref.cityIds)) {
                        ;
                        jobLocations = (ref1 = response.facets) === null || ref1 === void 0 ? void 0 : ref1.cityIds;
                    }
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.jobs = jobs, _tmp1.jobTotal = jobTotal, _tmp1.jobLocations = jobLocations, _tmp1)
                    ];
            }
        });
    });
    return function doGetJobList(companyId, accessToken, searchQuery, page, locationIds, userId, hitsPerPage, langCode) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./helpers/encode.ts
var encode = __webpack_require__(68325);
;// CONCATENATED MODULE: ./components/Icons/NarrowArrow/index.tsx


var NarrowArrow = function(param) {
    var direction = param.direction, _size = param.size, size = _size === void 0 ? 32 : _size, _fill = param.fill, fill = _fill === void 0 ? "#616161" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        transform: "rotate(".concat(direction === "right" ? 180 : 0, ")"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19.3121 8.5003C19.1352 8.50557 18.9672 8.57952 18.8439 8.70647L12.0331 15.517C11.9055 15.6447 11.8337 15.8179 11.8337 15.9985C11.8337 16.1791 11.9055 16.3523 12.0331 16.4801L18.8439 23.2906C18.9066 23.356 18.9818 23.4081 19.065 23.4441C19.1482 23.48 19.2377 23.499 19.3283 23.5C19.4189 23.5009 19.5088 23.4837 19.5927 23.4495C19.6766 23.4152 19.7528 23.3646 19.8169 23.3005C19.8809 23.2364 19.9316 23.1602 19.9658 23.0763C20.0001 22.9924 20.0172 22.9026 20.0163 22.8119C20.0154 22.7213 19.9964 22.6318 19.9605 22.5486C19.9245 22.4655 19.8723 22.3903 19.807 22.3275L13.4778 15.9985L19.807 9.66953C19.9054 9.57386 19.9726 9.4507 19.9998 9.31618C20.027 9.18166 20.013 9.04205 19.9595 8.91566C19.906 8.78927 19.8155 8.68198 19.7 8.60786C19.5845 8.53374 19.4493 8.49625 19.3121 8.5003Z",
            fill: fill
        })
    });
};
/* harmony default export */ var Icons_NarrowArrow = (/*#__PURE__*/(0,react.memo)(NarrowArrow));

;// CONCATENATED MODULE: ./components/JobList/index.tsx

















var JOB_PER_PAGE_DEFAULT = 20;
var JOB_PER_PAGE_MAXIMUM = 200;
var JobList_EMPTY_IMAGE = "".concat("https://images.vietnamworks.com", "/company-assets/images/icon-jobs1x.png");
var JobList = function(props) {
    var t = props.t, companyInfo = props.companyInfo, enablePagination = props.enablePagination;
    var _state = (0,store.useStore)().state, user = _state.user, langCode = _state.langCode, isMobile = _state.isMobile, isRobot = _state.isRobot, companyJobs = _state.companyJobs;
    var useDidUpdateEffect = hooks/* useDidUpdateEffect */.Dz, useDebounce = hooks_useDebounce/* default */.Z;
    var ref = (0,react.useState)(enablePagination ? JOB_PER_PAGE_DEFAULT : JOB_PER_PAGE_MAXIMUM), jobPerPage = ref[0], setJobPerPage = ref[1];
    var ref1 = (0,react.useState)((companyJobs === null || companyJobs === void 0 ? void 0 : companyJobs.jobs) || []), jobList = ref1[0], setJobList = ref1[1];
    var ref2 = (0,react.useState)(isRobot ? (companyJobs === null || companyJobs === void 0 ? void 0 : companyJobs.jobTotal) || 0 : 0), totalJobs = ref2[0], setTotalJobs = ref2[1];
    var ref3 = (0,react.useState)(0), page = ref3[0], setPage = ref3[1];
    var ref4 = (0,react.useState)(isRobot ? (companyJobs === null || companyJobs === void 0 ? void 0 : companyJobs.jobLocations) || [] : []), locationId = ref4[0], setLocationId = ref4[1];
    var ref5 = (0,react.useState)(""), searchQuery = ref5[0], setSearchQuery = ref5[1];
    var ref6 = (0,react.useState)([]), cityOptions = ref6[0], setCityOptions = ref6[1];
    var ref7 = (0,react.useState)(true), isHaveJobs = ref7[0], setIsHaveJobs = ref7[1];
    var jobListRef = (0,react.useRef)(null);
    var isDidMountedRef = (0,react.useRef)(false);
    var debouncedQuery = useDebounce(searchQuery, 1000);
    var jobPerPageOptions = [
        {
            id: 20,
            name: "".concat(t("Jobs per page"), ": 20")
        },
        {
            id: 50,
            name: "".concat(t("Jobs per page"), ": 50")
        },
        {
            id: 100,
            name: "".concat(t("Jobs per page"), ": 100")
        },
        {
            id: 200,
            name: "".concat(t("Jobs per page"), ": 200")
        }
    ];
    var getLocalizedOptions = function(data) {
        return data.map(function(param) {
            var id = param.id, name = param.name, nameEn = param.nameEn;
            return {
                id: id,
                name: langCode === constants/* ELanguage.EN */.Df.EN ? nameEn : name
            };
        });
    };
    var goToTopJobList = function() {
        // Timeout 20ms to make sure
        setTimeout(function() {
            var ref;
            (ref = jobListRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, 20);
    };
    var handleNavigatePage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            var ref, jobs, jobTotal;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId)) return [
                            3,
                            2
                        ];
                        isDidMountedRef.current = true;
                        return [
                            4,
                            doGetJobList((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, (user === null || user === void 0 ? void 0 : user.accessToken) || "", searchQuery, page, locationId, user === null || user === void 0 ? void 0 : user.userId, jobPerPage, langCode)
                        ];
                    case 1:
                        ref = _state.sent(), jobs = ref.jobs, jobTotal = ref.jobTotal;
                        setJobList(jobs);
                        setPage(page);
                        setTotalJobs(jobTotal);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNavigatePage(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleJobPerPageChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(jobPerPage) {
            var ref, jobs, jobTotal;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setJobPerPage(jobPerPage);
                        setPage(0);
                        isDidMountedRef.current = true;
                        return [
                            4,
                            doGetJobList((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, (user === null || user === void 0 ? void 0 : user.accessToken) || "", searchQuery, 0, locationId, user === null || user === void 0 ? void 0 : user.userId, jobPerPage, langCode)
                        ];
                    case 1:
                        ref = _state.sent(), jobs = ref.jobs, jobTotal = ref.jobTotal;
                        setJobList(jobs);
                        setTotalJobs(jobTotal);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleJobPerPageChange(jobPerPage) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleViewMoreJob = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(jobPerPage) {
            var ref, jobs, jobTotal;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setJobPerPage(jobPerPage);
                        setPage(0);
                        return [
                            4,
                            doGetJobList((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, (user === null || user === void 0 ? void 0 : user.accessToken) || "", searchQuery, 0, locationId, user === null || user === void 0 ? void 0 : user.userId, jobPerPage, langCode)
                        ];
                    case 1:
                        ref = _state.sent(), jobs = ref.jobs, jobTotal = ref.jobTotal;
                        setJobList(jobs);
                        setTotalJobs(jobTotal);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleViewMoreJob(jobPerPage) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLocationChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(locationId) {
            var ref, jobs, jobTotal;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLocationId(locationId);
                        setPage(0);
                        return [
                            4,
                            doGetJobList((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, (user === null || user === void 0 ? void 0 : user.accessToken) || "", searchQuery, 0, locationId, user === null || user === void 0 ? void 0 : user.userId, 200, langCode)
                        ];
                    case 1:
                        ref = _state.sent(), jobs = ref.jobs, jobTotal = ref.jobTotal;
                        setJobList(jobs);
                        setTotalJobs(jobTotal);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLocationChange(locationId) {
            return _ref.apply(this, arguments);
        };
    }();
    var getCompanyJobs = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var accessToken, ref, jobs, jobTotal, jobLocations;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        accessToken = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                        if (!(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId)) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            doGetJobList((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, accessToken, searchQuery, page, locationId, user === null || user === void 0 ? void 0 : user.userId, jobPerPage, langCode)
                        ];
                    case 1:
                        ref = _state.sent(), jobs = ref.jobs, jobTotal = ref.jobTotal, jobLocations = ref.jobLocations;
                        setJobList((0,_to_consumable_array/* default */.Z)(jobs));
                        setTotalJobs(jobTotal);
                        setCityOptions(getLocalizedOptions(index_modern/* initialDataProvider.getLocationNameFromIds */.Bz.getLocationNameFromIds(jobLocations || [])));
                        setIsHaveJobs(jobs.length > 0);
                        return [
                            2
                        ];
                }
            });
        });
        return function getCompanyJobs() {
            return _ref.apply(this, arguments);
        };
    }();
    var onUpdateUser = function(e) {
        var ref;
        if (!((ref = e.detail.user) === null || ref === void 0 ? void 0 : ref.accessToken)) {
            return;
        }
        // get job list again (with user updated)
        if (!jobList.length) {
            var ref1, ref2;
            getCompanyJobs((ref1 = e.detail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.accessToken);
        }
    };
    (0,react.useEffect)(function() {
        if (!isDidMountedRef.current) {
            return;
        }
        goToTopJobList();
    }, [
        jobList,
        isDidMountedRef.current
    ]);
    // init job list
    (0,react.useEffect)(function() {
        getCompanyJobs((user === null || user === void 0 ? void 0 : user.accessToken) || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId,
        user
    ]);
    // delay search when keyword change
    useDidUpdateEffect(function() {
        setPage(0);
        doGetJobList((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, (user === null || user === void 0 ? void 0 : user.accessToken) || "", searchQuery, page, locationId, user === null || user === void 0 ? void 0 : user.userId, 200, langCode).then(function(param) {
            var jobs = param.jobs, jobTotal = param.jobTotal;
            setJobList(jobs);
            setTotalJobs(jobTotal);
        });
    }, [
        debouncedQuery
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener(components_constants/* UPDATE_USER */.AX, onUpdateUser);
        return function() {
            window.removeEventListener(components_constants/* UPDATE_USER */.AX, onUpdateUser);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var renderJobText = totalJobs > 1 ? "".concat(totalJobs, " ").concat(t("jobs")) : "".concat(totalJobs, " ").concat(t("job"));
    var ref8;
    var userInfo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
        jobLevelId: user === null || user === void 0 ? void 0 : user.jobLevelId[0],
        id: (ref8 = user === null || user === void 0 ? void 0 : user.id) !== null && ref8 !== void 0 ? ref8 : 0
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobListWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListHeader, {
                        isMobile: isMobile,
                        ref: jobListRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobListTitle, {
                            id: "OpeningJobHeader",
                            children: [
                                t("Opening Jobs"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobAmount, {
                                    children: [
                                        "(",
                                        renderJobText,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    isHaveJobs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        gutter: 16,
                        style: {
                            marginBottom: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                sm: 10,
                                md: 14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBox, {
                                    isDisplayRemoveIcon: searchQuery.length > 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                                            placeholder: t("Enter a job title"),
                                            onChange: function(e) {
                                                return setSearchQuery(e.target.value);
                                            },
                                            value: searchQuery,
                                            isDisplayRemoveIcon: searchQuery.length > 0
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchRemoveIcon, {
                                            onClick: function() {
                                                return setSearchQuery("");
                                            },
                                            isDisplay: searchQuery.length > 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveFillIcon/* default */.Z, {})
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 7,
                                md: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleSelect/* default */.Z, {
                                    type: "multipleApply",
                                    name: "job-location",
                                    langCode: langCode === "vi" ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN,
                                    selectPlaceholder: t("All locations"),
                                    selectPlaceholderColor: "#333333",
                                    dropdownPlacement: "bottom-end",
                                    dropdownTopPosition: 1,
                                    options: cityOptions,
                                    defaultSelect: locationId,
                                    limit: 3,
                                    limitText: t("You have selected up to three locations"),
                                    isMobile: isMobile,
                                    onChange: function(res) {
                                        return handleLocationChange(res.value);
                                    },
                                    floatingConfig: {
                                        position: "absolute",
                                        useWindowAsFlippingContainer: true
                                    }
                                }, "multi-select-location-".concat(locationId.join("-")))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 7,
                                md: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleRadio/* default */.Z, {
                                    name: "job-per-page",
                                    placeholder: t("Jobs per page"),
                                    options: jobPerPageOptions,
                                    value: jobPerPage,
                                    isMobile: isMobile,
                                    onChange: function(res) {
                                        return handleJobPerPageChange(res.value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCardWrapper, {
                        children: jobList && jobList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: jobList.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCard/* default */.Z, {
                                    data: item,
                                    langCode: langCode,
                                    isMobile: isMobile,
                                    isManagementJobPage: false,
                                    custom: {
                                        forceNormalJob: true,
                                        variant: "primary"
                                    },
                                    utm: "utm_source_navi=CompanyProfileBasic&utm_medium_navi=JobList&utm_campaign_navi=JobTitle",
                                    previewJob: {
                                        appMode: "production",
                                        baseUrl: "https://www.vietnamworks.com" || 0
                                    },
                                    /* robot={{ */ /*     enable: true, */ /*     data: item */ /* }} */ api: {
                                        accessToken: (0,encode/* decrypt */.pe)((user === null || user === void 0 ? void 0 : user.accessToken) || ""),
                                        baseUrl: "https://ms.vietnamworks.com" || 0,
                                        appId: "4_2jou0kf7tsqo4s0c048goswckossk48kgc4c80ksok40cwwcss",
                                        source: "Company container - Company detail - Opening jobs"
                                    },
                                    userInfo: userInfo,
                                    classSelector: "company_openingjobs",
                                    initData: {
                                        locations: index_modern/* initialDataProvider.getLocations */.Bz.getLocations(),
                                        jobFunctions: index_modern/* initialDataProvider.getJobFunction */.Bz.getJobFunction(),
                                        companyIndustries: index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries(),
                                        jobLevels: index_modern/* initialDataProvider.getLevels */.Bz.getLevels(),
                                        educations: index_modern/* initialDataProvider.getHighestDegrees */.Bz.getHighestDegrees(),
                                        countries: index_modern/* initialDataProvider.getCountries */.Bz.getCountries(),
                                        cities: index_modern/* initialDataProvider.getLocations */.Bz.getLocations(),
                                        districts: index_modern/* initialDataProvider.getDistricts */.Bz.getDistricts(),
                                        benefits: index_modern/* initialDataProvider.getBenefits */.Bz.getBenefits()
                                    },
                                    headingTagTitleJob: "h3"
                                }, "job-item-".concat(item.jobId));
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyDiv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobList_css_ImageWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: JobList_EMPTY_IMAGE,
                                            alt: t("There are currently no opening jobs."),
                                            layout: "fill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("There are currently no opening jobs.")
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            totalJobs > 0 && jobList.length > 0 && (enablePagination ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: isMobile ? "center" : "space-between",
                    flexWrap: "wrap",
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                outline: "none",
                                iconPosition: "left",
                                isIcon: true,
                                iconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_NarrowArrow, {
                                    direction: "left"
                                }),
                                disabled: !page,
                                onClick: function() {
                                    return handleNavigatePage(page - 1);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Span */.Dr, {
                                name: "body",
                                color: Colors/* colors.grey.40 */.O9.grey[40],
                                size: "medium",
                                children: [
                                    page + 1,
                                    " / ",
                                    Math.ceil(totalJobs / jobPerPage)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                outline: "none",
                                iconPosition: "right",
                                isIcon: true,
                                iconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_NarrowArrow, {
                                    direction: "right"
                                }),
                                disabled: Math.floor(totalJobs / jobPerPage) < 1 || Math.ceil(totalJobs / jobPerPage) === page + 1,
                                onClick: function() {
                                    return handleNavigatePage(page + 1);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: isMobile ? "100%" : 250
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleRadio/* default */.Z, {
                            name: "job-per-page",
                            placeholder: t("Jobs per page"),
                            options: jobPerPageOptions,
                            value: jobPerPage,
                            isMobile: isMobile,
                            onChange: function(res) {
                                return handleJobPerPageChange(res.value);
                            }
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                isMobile: isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    outline: "solid",
                    type: "default",
                    style: {
                        width: 150
                    },
                    onClick: function() {
                        return handleViewMoreJob(page + 1);
                    },
                    children: t("View more")
                })
            }))
        ]
    });
};
/* harmony default export */ var components_JobList = (/*#__PURE__*/(0,react.memo)(JobList));

// EXTERNAL MODULE: ./components/MasterLayout/index.tsx + 5 modules
var MasterLayout = __webpack_require__(9741);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseElementOnScreen/index.js
var UseElementOnScreen = __webpack_require__(85694);
;// CONCATENATED MODULE: ./components/Video/Video.css.tsx

function Video_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    width: 100%;\n    background: black;\n    /* padding-top: calc(9 / 16 * 100%); */\n    aspect-ratio: 3/2;\n"
    ]);
    Video_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Video_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    border: none;\n"
    ]);
    Video_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Video_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 184px;\n    height: 80px;\n    position: relative;\n    display: inline-block;\n"
    ]);
    Video_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var VideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13057b6f-0"
})(Video_css_templateObject());
var CompanyVideo = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-13057b6f-1"
})(Video_css_templateObject1());
var Video_css_ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13057b6f-2"
})(Video_css_templateObject2());

;// CONCATENATED MODULE: ./components/Video/index.tsx








var Video_EMPTY_IMAGE = "".concat("https://images.vietnamworks.com", "/company-assets/images/icon-videos1x.png");
var REGEX = /https:\/\/youtu.be/g;
var REPLACE_TEXT = "https://youtube.com/watch?v=";
var Video = function(param) {
    var t = param.t, videoUrls = param.videoUrls;
    var convertedUrl = (0,react.useMemo)(function() {
        if (videoUrls) {
            var initialUrl = videoUrls.length > 0 ? videoUrls[0] : "";
            if (REGEX.test(initialUrl)) {
                initialUrl = initialUrl.replace(REGEX, REPLACE_TEXT);
            }
            var youtubeUrl = initialUrl.replace("watch?v=", "embed/");
            var youtubeArr = youtubeUrl ? youtubeUrl.split("&") : "";
            var ref;
            var splitUrl = (ref = youtubeArr[0]) !== null && ref !== void 0 ? ref : "";
            return splitUrl;
        }
        return "";
    }, [
        videoUrls
    ]);
    var isRobot = (0,store.useStore)().state.isRobot;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(isRobot), isVideoLoaded = ref[0], setVideoLoaded = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(UseElementOnScreen/* default */.Z({
        target: videoRef,
        options: {
            threshold: 0.5
        }
    }), 1), isVideoOnScreen = ref1[0];
    (0,react.useEffect)(function() {
        if (isVideoOnScreen) {
            setVideoLoaded(true);
        }
    }, [
        isVideoOnScreen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: videoRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("Video")
            }),
            convertedUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper, {
                children: isVideoLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyVideo, {
                    className: "company-video",
                    src: convertedUrl,
                    allowFullScreen: true
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_css_ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: Video_EMPTY_IMAGE,
                            alt: t("There is no video for the moment."),
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("There is no video for the moment.")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Video = (Video);

;// CONCATENATED MODULE: ./components/CompanyDetail/translation.ts
var translations = {
    followers: "lượt theo d\xf5i",
    follower: "lượt theo d\xf5i",
    "Opening Jobs": "Vị tr\xed đang tuyển dụng",
    "About Us": "Về ch\xfang t\xf4i",
    Video: "Video",
    Benefits: "Ph\xfac lợi",
    Share: "Chia sẻ",
    "View all jobs": "Xem tất cả c\xf4ng việc",
    Address: "Địa chỉ",
    Headquarter: "Trụ sở ch\xednh",
    Size: "Quy m\xf4",
    Categories: "Ng\xe0nh nghề",
    Industry: "Lĩnh vực",
    Contact: "Li\xean hệ",
    "Read more": "Xem th\xeam",
    "Show less": "Thu gọn",
    "Company Video": "Video Về C\xf4ng Ty",
    "Company Benefits": "Ph\xfac Lợi C\xf4ng Ty",
    "You are following": "Đang theo d\xf5i",
    Following: "Đang theo d\xf5i",
    Follow: "Theo d\xf5i",
    "There are currently no opening jobs.": "C\xf4ng ty hiện kh\xf4ng tuyển dụng.",
    "There is no video for the moment.": "C\xf4ng ty chưa cập nhật video giới thiệu.",
    "The company has not defined the benefits yet.": "C\xf4ng ty chưa cập nhật th\xf4ng tin về ph\xfac lợi.",
    "You'll stop receive the newest jobs from this company.": "Bạn sẽ ngừng nhận th\xf4ng b\xe1o về c\xf4ng việc mới nhất từ ​​c\xf4ng ty n\xe0y.",
    Updated: "Cập nhật",
    "Posted on": "Đăng ng\xe0y",
    "You have": "Bạn c\xf2n",
    "days to apply": "ng\xe0y để ứng tuyển",
    "day to apply": "ng\xe0y để ứng tuyển",
    Expire: "Hết hạn",
    "TODAY!": "H\xd4M NAY!",
    Posted: "Đ\xe3 đăng",
    "Expires: ": "Hết hạn: ",
    in: "trong",
    "Expires on today": "Hết hạn trong h\xf4m nay",
    day: "ng\xe0y",
    "Up to": "L\xean đến",
    Bonus: "Thưởng",
    "Healthcare Plan": "Kh\xe1m sức khỏe",
    "Paid Leave": "Nghỉ ph\xe9p",
    Training: "Đ\xe0o tạo",
    Awards: "Giải thưởng",
    Library: "Thư viện",
    Laptop: "Laptop",
    Mobile: "Điện thoại",
    "Travel Opportunities": "Du lịch",
    "Team Activities": "Hoạt động",
    Transportation: "Trợ cấp đi lại",
    Canteen: "Căn-tin",
    Vouchers: "Thưởng qu\xe0",
    Kindergarten: "Tr\xf4ng trẻ",
    Others: "Kh\xe1c",
    Map: "Bản đồ",
    NEW: "MỚI",
    staffs: "nh\xe2n vi\xean",
    job: "việc l\xe0m",
    jobs: "việc l\xe0m",
    "You should": "Bạn phải",
    "Sign In": "đăng nhập",
    "to save jobs": "để lưu c\xf4ng việc",
    Applied: "Đ\xe3 Nộp Đơn",
    "Search for jobs hiring using our Job Search. Thousands of jobs in different field in Vietnam. Find your dream jobs and apply with just 1 click now!": "Th\xf4ng tin tuyển dụng tất cả c\xe1c việc l\xe0m tr\xean to\xe0n quốc với mức lương cao, hấp dẫn chế độ đ\xe3i ngộ tốt. T\xecm kiếm nhanh việc l\xe0m tại website VietnamWorks!",
    "Yay! Thanks for following": "Cảm ơn bạn đ\xe3 theo d\xf5i",
    Unfollowed: "Đ\xe3 bỏ theo d\xf5i",
    Unfollow: "Bỏ theo d\xf5i",
    "You will receive the newest jobs from this company.": "Bạn sẽ nhận được th\xf4ng b\xe1o về c\xf4ng việc mới nhất từ c\xf4ng ty n\xe0y.",
    "You will not able to received notifications from this company.": "Bạn sẽ ngừng nhận th\xf4ng tin việc l\xe0m từ c\xf4ng ty n\xe0y.",
    "Unfollow company?": "Bỏ theo d\xf5i c\xf4ng ty?",
    "View more": "Xem th\xeam",
    "Enter a job title": "Nhập chức danh",
    "All locations": "Tất cả địa điểm",
    "You have selected up to three locations": "Bạn đ\xe3 chọn tối đa ba địa điểm",
    "{companyName} latest recruitment {now} - VietnamWorks": "{companyName} tuyển dụng mới nhất {now} - VietnamWorks",
    "{companyName} is recruiting for many attractive positions on VietnamWorks with high salary and good benefits. See jobs at {companyName} and apply now!": "{companyName} đang tuyển dụng nhiều vị tr\xed hấp dẫn tr\xean VietnamWorks với mức lương cao, đ\xe3i ngộ tốt. Xem việc l\xe0m tại {companyName} v\xe0 ứng tuyển ngay!",
    "Trusted company": "C\xf4ng ty uy t\xedn",
    "Just removed 1 save job": "Bạn vừa x\xf3a 1 c\xf4ng việc",
    "You have saved job, view": "Bạn đ\xe3 lưu việc l\xe0m th\xe0nh c\xf4ng, xem ",
    "My jobs": "Việc l\xe0m của t\xf4i",
    Success: "Th\xe0nh c\xf4ng",
    "/my-career-center/my-jobs?section=saved": "/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved",
    "Jobs per page": "C\xf4ng việc mỗi trang",
    "Home page": "Trang chủ",
    Jobs: "Việc l\xe0m",
    "Job at": "Việc l\xe0m tại",
    "/job-search": "/tim-viec-lam",
    "View map": "Xem bản đồ"
};
/* harmony default export */ var translation = (translations);

;// CONCATENATED MODULE: ./components/CompanyDetail/index.tsx
/* provided dependency */ var process = __webpack_require__(83454);




















var _NEXT_PUBLIC_MICROSERVICE_DOMAIN;
var msBaseUrl = (_NEXT_PUBLIC_MICROSERVICE_DOMAIN = process.env.NEXT_PUBLIC_MICROSERVICE_DOMAIN) !== null && _NEXT_PUBLIC_MICROSERVICE_DOMAIN !== void 0 ? _NEXT_PUBLIC_MICROSERVICE_DOMAIN : "";
var EMPTY_BANNER_IMAGE = "".concat("https://images.vietnamworks.com", "/company-assets/images/banner-default-company.png");
var DELAY_HANDLER_TIME = 100;
var isOptOutUserAgentFilter = "0" === "1";
var SelectTab;
(function(SelectTab) {
    SelectTab[SelectTab["ABOUT_US"] = 0] = "ABOUT_US";
    SelectTab[SelectTab["OPENING_JOB"] = 1] = "OPENING_JOB";
    SelectTab[SelectTab["VIDEO"] = 2] = "VIDEO";
    SelectTab[SelectTab["BENEFITS"] = 3] = "BENEFITS";
})(SelectTab || (SelectTab = {}));
var CompanyDetail = function(props) {
    var jsToken = props.jsToken, wsToken = props.wsToken, langCode = props.langCode, user = props.user, appMode = props.appMode, infoPath = props.infoPath, metaHead = props.metaHead, companyOCIData = props.companyOCIData, seoKeywords = props.seoKeywords;
    var ref = (0,store.useStore)(), dispatch = ref.dispatch, state = ref.state;
    var trackingQueue = (0,useHog/* default */.Z)().trackingQueue;
    (0,useIdentify/* default */.ZP)(user, msBaseUrl);
    // company info
    var ref1 = (0,react.useState)(props.companyProfile), companyProfile = ref1[0], setCompanyProfile = ref1[1];
    // tab select
    var ref2 = (0,react.useState)(SelectTab.ABOUT_US), selectedTab = ref2[0], setSelectedTab = ref2[1];
    var ref3 = (0,react.useState)(false), isMobile = ref3[0], setIsMobile = ref3[1];
    var jobListWrapperRef = (0,react.useRef)(null);
    var aboutUsSectionRef = (0,react.useRef)(null);
    var t = function(text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        } else {
            return translation[text];
        }
    };
    var onTabSelected = function(tab) {
        setSelectedTab(tab);
        var selectedTabRef = tab === SelectTab.ABOUT_US ? aboutUsSectionRef : jobListWrapperRef;
        window.scrollTo({});
        helpers/* debounceHandler */.BN(function() {
            var ref;
            (ref = selectedTabRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, DELAY_HANDLER_TIME)();
    };
    if ((metaHead === null || metaHead === void 0 ? void 0 : metaHead.title) === "") {
        var now = new Date();
        var current = langCode === constants/* ELanguage.EN */.Df.EN ? now.toLocaleDateString("en-US", {
            month: "short"
        }) + ", " + now.getFullYear() : "T" + (now.getMonth() + 1) + "/" + now.getFullYear();
        var ref4;
        metaHead.title = t("{companyName} latest recruitment {now} - VietnamWorks").replace(/\{companyName\}/g, (ref4 = companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyName) !== null && ref4 !== void 0 ? ref4 : "").replace("{now}", current);
        var ref5;
        metaHead.description = t("{companyName} is recruiting for many attractive positions on VietnamWorks with high salary and good benefits. See jobs at {companyName} and apply now!").replace(/\{companyName\}/g, (ref5 = companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyName) !== null && ref5 !== void 0 ? ref5 : "");
    }
    var handleResize = function() {
        if (true) {
            if (window.innerWidth > 768) setIsMobile(false);
            else setIsMobile(true);
        }
    };
    var updateUserState = function(e) {
        var ref, ref1, ref2, ref3;
        if (!(e === null || e === void 0 ? void 0 : (ref = e.detail) === null || ref === void 0 ? void 0 : ref.user)) {
            return;
        }
        dispatch({
            type: actions/* ACTION_SET_USER */.gS,
            payload: e === null || e === void 0 ? void 0 : (ref1 = e.detail) === null || ref1 === void 0 ? void 0 : ref1.user
        });
        getCompanyDetail((e === null || e === void 0 ? void 0 : (ref2 = e.detail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.userId) || 0);
    };
    var getCompanyDetail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(userId) {
            var ref, meta, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,companyDetailService/* companyDetailService */.G_)(infoPath, userId, langCode)
                        ];
                    case 1:
                        ref = _state.sent(), meta = ref.meta, data = ref.data;
                        if (data === null || meta.code !== 200) {
                            return [
                                2
                            ];
                        }
                        setCompanyProfile(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getCompanyDetail(userId) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        trackingQueue({
            eventName: "js_platform_discovery:company_profile_view",
            properties: {
                companyId: (companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyId) || "",
                companyIndustry: (companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.industryNames) || "",
                companyName: (companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyName) || "",
                isCcp: !!(companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.clpInfo),
                follower: Number(companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.totalFollow),
                totalJobs: Number((ref = state.companyJobs) === null || ref === void 0 ? void 0 : ref.jobTotal),
                isReport: !!(companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.isReported)
            }
        });
        handleResize();
        window.scrollTo(0, 0);
        window.addEventListener("resize", handleResize);
        window.addEventListener(components_constants/* UPDATE_USER */.AX, updateUserState);
        return function() {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener(components_constants/* UPDATE_USER */.AX, updateUserState);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (user === null) {
            return;
        }
        dispatch({
            type: actions/* ACTION_SET_USER */.gS,
            payload: user
        });
    }, [
        dispatch,
        user
    ]);
    (0,react.useEffect)(function() {
        dispatch({
            type: actions/* ACTION_SET_LANGUAGE */.YZ,
            payload: langCode
        });
    }, [
        dispatch,
        langCode
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        var handleSectionVisibilityChangeCallback = helpers/* debounceHandler */.BN(function() {
            if (!jobListWrapperRef.current) {
                return;
            }
            var isJobListSectionInViewPort = jobListWrapperRef.current.getBoundingClientRect().top <= 50;
            if (isJobListSectionInViewPort && selectedTab !== SelectTab.OPENING_JOB) {
                setSelectedTab(SelectTab.OPENING_JOB);
            } else if (!isJobListSectionInViewPort && selectedTab === SelectTab.OPENING_JOB) {
                setSelectedTab(SelectTab.ABOUT_US);
            }
        }, 30);
        document.addEventListener("scroll", handleSectionVisibilityChangeCallback);
        return function() {
            return document.removeEventListener("scroll", handleSectionVisibilityChangeCallback);
        };
    }, [
        selectedTab
    ]);
    var companyBannerImage = companyProfile !== null && companyProfile.bannerDesktopUri !== "" ? companyProfile.bannerDesktopUri : EMPTY_BANNER_IMAGE;
    var _NEXT_PUBLIC_POSTHOG_API_KEY, _NEXT_PUBLIC_POSTHOG_API_HOST;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HogProvider/* default */.Z, {
        posthogConfig: {
            key: (_NEXT_PUBLIC_POSTHOG_API_KEY = "phc_MPcl1lKQzHItt2rWP3yrQgoIeqjtTgJ4ngki2IWCP5A") !== null && _NEXT_PUBLIC_POSTHOG_API_KEY !== void 0 ? _NEXT_PUBLIC_POSTHOG_API_KEY : "",
            host: (_NEXT_PUBLIC_POSTHOG_API_HOST = "https://pht.vietnamworks.com") !== null && _NEXT_PUBLIC_POSTHOG_API_HOST !== void 0 ? _NEXT_PUBLIC_POSTHOG_API_HOST : "",
            options: {
                optOutUserAgentFilter: isOptOutUserAgentFilter
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MasterLayout/* default */.Z, {
            seoKeywords: seoKeywords,
            appMode: appMode,
            langCode: langCode,
            jsToken: jsToken,
            wsToken: wsToken,
            isMobileScale: isMobile,
            noOffsetContainer: true,
            metaHead: metaHead,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyPageContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWithBordered, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Banner, {
                                t: t,
                                companyInfo: companyProfile,
                                onTabChange: onTabSelected,
                                selectedTab: selectedTab,
                                companyBannerImage: companyBannerImage
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWithBordered, {
                            ref: aboutUsSectionRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* ContentWrapper */.vs, {
                                    isPadding: true,
                                    id: "AboutUs",
                                    noObjectFit: true,
                                    hasBg: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AboutUs, {
                                        t: t,
                                        companyInfo: companyProfile,
                                        ociData: companyOCIData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* ContentWrapper */.vs, {
                                    isPadding: true,
                                    id: "Video",
                                    hasBg: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Video, {
                                        t: t,
                                        videoUrls: (companyOCIData === null || companyOCIData === void 0 ? void 0 : companyOCIData.companyVideos) || (companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.jobVideoURLs)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* ContentWrapper */.vs, {
                                    isPadding: true,
                                    id: "Benefit",
                                    hasBg: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Benefit, {
                                        t: t,
                                        companyInfo: companyProfile,
                                        ociData: companyOCIData
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWithBordered, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_css/* ContentWrapper */.vs, {
                                ref: jobListWrapperRef,
                                id: "OpeningJob",
                                isPadding: true,
                                hasBg: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_JobList, {
                                    t: t,
                                    companyInfo: companyProfile,
                                    enablePagination: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreadcrumbStyle, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Anchor */.ee, {
                            href: "https://www.vietnamworks.com",
                            name: "body",
                            size: "small",
                            style: {
                                cursor: "pointer"
                            },
                            color: Colors/* colors.primary.40 */.O9.primary[40],
                            children: t("Home page")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_NarrowArrow, {
                            direction: "right",
                            size: 14
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Anchor */.ee, {
                            href: "".concat("https://www.vietnamworks.com").concat(t("/job-search")),
                            name: "body",
                            size: "small",
                            style: {
                                cursor: "pointer"
                            },
                            color: Colors/* colors.primary.40 */.O9.primary[40],
                            children: t("Jobs")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_NarrowArrow, {
                            direction: "right",
                            size: 14
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Span */.Dr, {
                            name: "body",
                            size: "small",
                            color: Colors/* colors.grey.40 */.O9.grey[40],
                            children: [
                                t("Job at"),
                                " ",
                                companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyName
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GotoTop/* default */.Z, {
                    trackId: "bannerSection"
                })
            ]
        })
    });
};
/* harmony default export */ var components_CompanyDetail = (CompanyDetail);


/***/ })

}]);